import { t, Trans } from '@lingui/macro'
import { Box, Divider, Typography } from '@mui/material'
import { Text, View } from '@react-pdf/renderer'
import { myI18n } from 'translation/I18nConnectedProvider'
import './FutureAspect.css'

const FutureAspect = ({
  containsAggragatedData,
  item,
  data,
  classes,
  renderPdf = false,
  pdfStyles
}) => {
  let name = ''
  let text = ''
  let ability = ''

  const level = data.Future[item]
  if (item === 'viability') {
    name = t`Viability`
    text = t`maintain current service levels.`
  } else if (item === 'resilience') {
    name = t`Resilience`
    text = t`adapt to a challenge to meet future housing needs.`
  } else if (item === 'vitality') {
    name = t`Vitality`
    text = t`react to changing needs.`
  }
  if (level <= 0.5) {
    ability = containsAggragatedData
      ? t`SCORE_CARD_AGGREGATED_BELIEVE_UNABLE`
      : t`You believe that your organization is unable to `
  } else if (level <= 1.5) {
    ability = containsAggragatedData
      ? t`SCORE_CARD_AGGREGATED_BELIEVE_SOMEWHAT_ABLE`
      : t`You believe that your organization is somewhat able to `
  } else {
    ability = containsAggragatedData
      ? t`SCORE_CARD_AGGREGATED_BELIEVE_FULLY_ABLE`
      : t`You believe that your organization is fully able to `
  }

  if (renderPdf) {
    return (
      <View>
        <View style={{ flexDirection: 'row', width: '100%' }}>
          <Text style={[pdfStyles.futureTitle, { width: '20%' }]}>
            {myI18n._(name)}
          </Text>
          <Text style={[pdfStyles.futureDescription, { width: '80%', paddingRight: 10 }]}>
            {myI18n._(ability)} {myI18n._(text)}
          </Text>
        </View>
        <View style={pdfStyles.futureDivider} />
      </View>
    )
  }

  return (
    <Box>
      <Box key={name} className='row'>
        <Typography className='future-title'>
          <Trans id={name} />
        </Typography>
        <Typography className='future-description'>
          <Trans id={ability} />
          {' '}
          <Trans id={text} />
        </Typography>
      </Box>
      <Divider className='divider' />
    </Box>
  )
}

export default FutureAspect
